import {configureStore} from '@reduxjs/toolkit';
import {combineReducers} from 'redux';
// import expressPaymentMethodReducer from './payment-methods/express-payment-methods';
// import paymentMethodReducer from './payment-methods';
// import productReducer from './product';
// import productGroupReducer from './product-group';
import pluginReducer from './plugin'
import subscriptionsReducer from './subscriptions';
import checkoutReducer from './checkout';
import {updateCheckoutData} from './store-changes';
import getSetting from "../utils/settings";

const store = configureStore({
    reducer: combineReducers({
        plugins: pluginReducer,
        subscriptions: subscriptionsReducer,
        // paymentMethod: paymentMethodReducer,
        // expressPaymentMethods: expressPaymentMethodReducer,
        // product: productReducer,
        // productGroup: productGroupReducer,
        checkout: checkoutReducer
    })
});

if (getSetting('page') === 'checkout') {
    store.subscribe(updateCheckoutData(store));
}

const {dispatch} = store;

export {dispatch};

export default store;
